module.exports = __webpack_public_path__ + "img/black-friday-sale.dcbacd71.png";